import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { connect } from 'react-redux';
import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n';
import { loadShopNetworkMenu, loadShopDetail } from './actions';
import { ContentWithSidebar } from '../../theme/libraries/grid';
import { getBaseUrl } from '../../utilities';
import API from '../../services/API';
import StoreDetail from '../../components/_layout/Stores/StoreDetail';
import SidebarContainer from '../../components/_layout/Sidebar/Sidebar';
import { push } from 'react-router-redux';
import styled from 'styled-components';
import { rem } from 'polished';
import { Loader } from '../../components/_helpers/Loader/Loader';
import ContentContainerWithSidebar from '../../components/_layout/Page/ContentContainerWithSidebar';
import { setCurrentUniqs } from '../App/actions';

const ShopNotFound = styled.div`
  font-size: ${rem(25)}
  text-align: center;
`;

const LoaderWrapper = styled.div`
  margin-top: ${rem(50)};
`;

export interface ShopDetailProps {
  shopNetworkMenu: any;
  shopDetail: any;
  shops: any;
  dispatch: any;
}

class ShopDetail extends React.Component<ShopDetailProps> {
  public static async getInitialProps(props) {
    const [, , shopsResponse] = await Promise.all([
      props.dispatch(loadShopNetworkMenu()),
      props.dispatch(loadShopDetail(props.webShopId)),
      API.loadShops(),
    ]);

    return { ...props, shops: shopsResponse?.shops || [] };
  }

  constructor(props) {
    super(props);
  }

  public componentDidMount() {
    this.props.dispatch(setCurrentUniqs(['SHOP_NETWORK']));
  }

  public componentWillUnmount() {
    this.props.dispatch(setCurrentUniqs([]));
  }

  public onBackClick = () => {
    this.props.dispatch(push(getBaseUrl('/predajne')));
  };

  public render() {
    const { shopNetworkMenu, shopDetail, shops } = this.props;

    const shopsMenu = [
      {
        url: '/predajne',
        text: __('Všetky predajne'),
        active: false,
      },
      ...(shops || []).map((shop) => ({
        url: shop.url,
        text: shop.name,
        active: !!shopDetail && shop.id === shopDetail.id,
      })),
    ];

    const shopListItem = shopNetworkMenu?.find(
      (item) => item.uniqid === 'SHOP_LIST',
    );

    const breadcrumbItems = [
      { name: __('Úvod'), url: '/' },
      { name: __('Predajňe'), url: '/predajne' },
    ];

    if (shopListItem) {
      breadcrumbItems.push({
        name: shopListItem.name,
        url: shopListItem.url,
      });
    }

    if (shopDetail) {
      breadcrumbItems.push({
        name: shopDetail.name,
        url: shopDetail.url,
      });
    }

    return (
      <ContentContainerWithSidebar>
        {shopNetworkMenu && (
          <React.Fragment>
            <SidebarContainer items={shopsMenu} />
            <ContentWithSidebar fullWidth={false}>
              {shopDetail ? (
                <StoreDetail
                  detail={shopDetail}
                  breadcrumbItems={breadcrumbItems}
                  onClickBack={this.onBackClick}
                />
              ) : (
                <React.Fragment>
                  {shopDetail === undefined && (
                    <LoaderWrapper>
                      <Loader loading={true} />
                    </LoaderWrapper>
                  )}
                  {shopDetail === null && (
                    <ShopNotFound> {__('PREDAJŇA N/A')}</ShopNotFound>
                  )}
                </React.Fragment>
              )}
            </ContentWithSidebar>
          </React.Fragment>
        )}
      </ContentContainerWithSidebar>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    shopNetworkMenu: state.shopDetail.shopNetworkMenu,
    shopDetail: state.shopDetail.shopDetail,
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'ShopDetail' })(ShopDetail),
);
